import {ElementRef, Renderer2} from "@angular/core";
import {Subscription} from "rxjs";

import {MixinConstructor} from "./mixin.define";
import {GlobalEventService} from "../services/global-event/global-event.service";


type ClickOutsideMixin = {
  elementRef: ElementRef,
  renderer: Renderer2,
  globalEventSvc: GlobalEventService,
};


/**
 * 단일 mixin을 사용하는 경우의 정의.
 */
export const clickOutsideLinkMixin = ClickOutsideMixinFunction(
  class Parent {
    constructor(
      public elementRef: ElementRef,
      public renderer: Renderer2,
      public globalEventSvc: GlobalEventService,
    ) {}
  }
);

export function ClickOutsideMixinFunction<BaseType extends MixinConstructor<ClickOutsideMixin>>(BaseClass: BaseType) {
  return class extends BaseClass {
    constructor(...args: any[]) {
      super(...args);
    }

    private coUnClick: (() => void) | null = null;
    private coUnTouchMove: (() => void) | null = null;
    private coUnWheel: (() => void) | null = null;
    private coGlobal$: Subscription | null = null;
    private coPreventCloseFlag = false;

    protected coInit(fnClose: (event: MouseEvent|TouchEvent) => void) {
      console.log('ClickOutsideMixinFunction::coInit()');

      const handleEvent = (event: MouseEvent|TouchEvent|WheelEvent) => {
        const isClickedOutside = !this.elementRef.nativeElement.contains(event.target);
        if (isClickedOutside && !this.coPreventCloseFlag) {
          // 컴포넌트 외부를 클릭한 경우
          fnClose(event);
        }
      };

      // 'click' 이벤트 리스너 추가
      this.coUnClick = this.renderer.listen('window', 'click', handleEvent);
      this.coUnTouchMove = this.renderer.listen('window', 'touchmove', handleEvent);
      this.coUnWheel = this.renderer.listen('window', 'wheel', handleEvent);

      this.coGlobal$ = this.globalEventSvc.Click$.subscribe(event => {
        const isClickedOutside = !this.elementRef.nativeElement.contains(event.target);
        if (isClickedOutside && !this.coPreventCloseFlag) {
          fnClose(event);
        }
      });
    }

    protected coDestroy() {
      this.coUnClick?.();
      this.coUnTouchMove?.();
      this.coUnWheel?.();
      this.coGlobal$?.unsubscribe();
    }

    /**
     * 일시적으로 팝업창 외부를 눌러도, 창이 닫히지 않도록 막는다.
     *
     * @param flag - true = 막기, false = 막지 않기
     * @protected
     */
    protected coPreventClose(flag = true) {
      this.coPreventCloseFlag = flag;
    }
  }
}
